import { AppStates } from "@/models/AppStates";
import { AppUsers } from "@/models/AppUsers";
import jQuery from "jquery"
import { MyUrls } from "./MyWorkUrls";

Object.assign(window, { $: jQuery, jQuery })

export const myThryveUrl = MyUrls.getWearable();//"https://emmie-backend.offis.de/rest/thryves";

export const myThryveXMLHTTPRequests = {

    

    async askMyServer(){
        return await AppUsers.getMyUser().then((user) => {
            console.log(user.sysId)

            return new Promise((resolve,reject) => {
                var data = "partnerUserID="+user.sysId+"&language=en&sourceNb=8&what=askMyServer";
               
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.addEventListener("readystatechange", function() {
                if(this.readyState === 4) {
                    resolve(this.responseText.replaceAll('"',''));
                }
                });

                xhr.open("POST", myThryveUrl);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");


                xhr.send(data);

            });
        })
    },

    async createThryveUser() {

        return await AppUsers.getMyUser().then((user) => {
            console.log(user.sysId)

            return new Promise((resolve,reject) => {
                var data = "partnerUserID="+user.sysId+"&language=en&sourceNb=8&what=getAlldataSourceDirectConnection";
               
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.addEventListener("readystatechange", function() {
                if(this.readyState === 4) {
                    resolve(this.responseText.replaceAll('"',''));
                }
                });

                xhr.open("POST", myThryveUrl);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.send(data);

            });
        })
    },

    async getThryveDayData(ViewDate: Date){
        //console.log(ViewDate)
        let startDay = new Date(ViewDate.getFullYear(),ViewDate.getMonth(),ViewDate.getDate(),0,0,0);
        let endDay = new Date(ViewDate.getFullYear(),ViewDate.getMonth(),ViewDate.getDate(),23,59,59);
        let userTimezoneOffset = startDay.getTimezoneOffset() * 60000;
        //console.log(startDay)
        return await AppUsers.getMyUser().then((user) => {
            //console.log(user.sysId)

            return new Promise((resolve,reject) => {
                var data = "partnerUserID="+user.sysId+"&language=en&sourceNb=8&what=getValues&startDateTime="+( startDay.getTime()  - userTimezoneOffset)+"&endDateTime="+(endDay.getTime() - userTimezoneOffset);
               console.log("getValues&startDateTime="+(startDay.getTime() - userTimezoneOffset)+"&endDateTime="+(endDay.getTime() - userTimezoneOffset));
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.addEventListener("readystatechange", function() {
                    //console.log(this)
                
                    if(this.readyState === 4) {
                        if(this.status == 0){
                            reject('unauthorized');
                            return
                        }
                        //console.log( JSON.parse(this.responseText));
                        resolve(JSON.parse(this.responseText));
                    }
                });

                xhr.open("POST", myThryveUrl);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.send(data);

            });
        })
    },

    async getThryveDayDataLongTerm(StartDate: Date, EndDate: Date){
        //console.log(ViewDate)
        let startDay = new Date(StartDate.getFullYear(),StartDate.getMonth(),StartDate.getDate(),0,0,0);
        let endDay = new Date(EndDate.getFullYear(),EndDate.getMonth(),EndDate.getDate(),23,59,59);
        let userTimezoneOffset = startDay.getTimezoneOffset() * 60000;
        //console.log(startDay)
        return await AppUsers.getMyUser().then((user) => {
            //console.log(user.sysId)

            return new Promise((resolve,reject) => {
                var data = "partnerUserID="+user.sysId+"&language=en&sourceNb=8&what=getValues&startDateTime="+( startDay.getTime()  - userTimezoneOffset)+"&endDateTime="+(endDay.getTime() - userTimezoneOffset);
               console.log("getValues&startDateTime="+(startDay.getTime() - userTimezoneOffset)+"&endDateTime="+(endDay.getTime() - userTimezoneOffset));
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.addEventListener("readystatechange", function() {
                    //console.log(this)
                
                    if(this.readyState === 4) {
                        if(this.status == 0){
                            reject('unauthorized');
                            return
                        }
                        //console.log( JSON.parse(this.responseText));
                        resolve(JSON.parse(this.responseText));
                    }
                });

                xhr.open("POST", myThryveUrl);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.send(data);

            });
        })
    },

    async getSWCDayDataLongTerm(StartDate: Date, EndDate: Date){
        //console.log(ViewDate)
        let startDay = new Date(Date.UTC(StartDate.getFullYear(),StartDate.getMonth(),StartDate.getDate(),-1,0,0));
        let endDay = new Date(Date.UTC(EndDate.getFullYear(),EndDate.getMonth(),EndDate.getDate(),22,59,59));
        let userTimezoneOffset = startDay.getTimezoneOffset() * 60000;
        //console.log(startDay)
        return await AppUsers.getMyUser().then((user) => {
            //console.log(user.sysId)

            return new Promise((resolve,reject) => {
                var data = "partnerUserID="+user.sysId+"&language=en&sourceNb=8&what=getSWCValues&startDateTime="+( startDay.getTime())+"&endDateTime="+(endDay.getTime());
               console.log("getValues&startDateTime="+(startDay.getTime() - userTimezoneOffset)+"&endDateTime="+(endDay.getTime() - userTimezoneOffset));
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.addEventListener("readystatechange", function() {
                    //console.log(this)
                
                    if(this.readyState === 4) {
                        if(this.status == 0){
                            reject('unauthorized');
                            return
                        }
                        //console.log( JSON.parse(this.responseText));
                        resolve(JSON.parse(this.responseText));
                    }
                });

                xhr.open("POST", myThryveUrl);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.send(data);

            });
        })
    },


    getThryveLinkData(){
        return {
        	"Fitbit":1,
        	"Garmin":2,
        	"Polar":3,
        	"Misfit":7,
        	"Withings":8,
        	"Strava":11,
        	"GoogleFit":12,
        	"Suunto":17,
        	"Oura":18,
        	"iHealth":21,
        	"Sleep As Android":24,
        	"Huawei Health":38,
        	"Amazfit":39
        }
    }
}